import { useState } from 'react';
import { api } from '../../utils/api';

export default function Login({ onError, onSuccess }) {
    const [mode, setMode] = useState('initial');
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: ''
    });

    const handleGoogleLogin = () => {
        window.location.href = `${process.env.REACT_APP_URL_backend}/auth/google`;
    };

    const handleEmailLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/api/users/login', {
                email: formData.email,
                password: formData.password
            });

            if (response.token) {
                localStorage.setItem('authToken', response.token);
                window.location.reload();
            }
        } catch (err) {
            if (err.status === 403) {
                onError('Your account is under review. Our team will contact you within 24 hours.');
            } else {
                onError('Invalid email or password');
            }
        }
    };

    const handleSignup = async (e) => { 
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            onError('Passwords do not match');
            return;
        }

        try {
            // Make sure barName is included and not empty
            if (!formData.barName?.trim()) {
                onError('Bar name is required');
                return;
            }

            const response = await api.post('/api/users/create-account', {
                username: formData.email.split('@')[0],
                email: formData.email,
                password: formData.password,
                barName: formData.barName.trim()
            });

            // If we get a response with account data, consider it a success
            if (response.account) {
                onError(null);
                // Store the email temporarily
                const registeredEmail = formData.email;
                // Reset form data
                setFormData({
                    email: registeredEmail, // Keep the email
                    password: '',
                    confirmPassword: ''
                });
                // Switch to login mode
                setMode('email-login');
                // Show success message
                onSuccess('Account created successfully! Please sign in.');
                return;
            }

            // If we get here without an account, something went wrong
            throw new Error('Failed to create account');

        } catch (err) {
            console.error('Signup error:', err);
            
            // Handle specific error codes from the backend
            switch (err.code) {
                case 'EMAIL_EXISTS':
                    onError('There is already an account registered with this email');
                    break;
                case 'BAR_NAME_EXISTS':
                    onError('This bar name is already taken');
                    break;
                case 'NETWORK_ERROR':
                    onError('Network error. Please try again.');
                    break;
                default:
                    // If the account was created but email failed, still consider it a success
                    if (err.message?.includes('PLAIN')) {
                        onError(null);
                        setMode('email-login');
                        onSuccess('Account created successfully! Please sign in.');
                    } else {
                        onError(err.message || 'Failed to sign up. Please try again.');
                    }
            }
        }
    };

    return {
        mode,
        setMode,
        formData,
        setFormData,
        handleGoogleLogin,
        handleEmailLogin,
        handleSignup
    };
}